import { ADD_BOM_TYPE, ADD_BOM_GROUP, GET_ALL_BOM, GET_FACTORY_PRODUCT_TYPES } from './BomType.type';

const initialState = {
  TypeList: [],
  GroupList: [],
  AllBomList: [],
  factoryProductTypeList: [],
};
const BomTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BOM_TYPE:
      return {
        ...state,
        TypeList: action.payload,
      };

    case ADD_BOM_GROUP:
      return {
        ...state,
        GroupList: action.payload,
      };

    case GET_ALL_BOM:
      return {
        ...state,
        AllBomList: action.payload,
      };
    case GET_FACTORY_PRODUCT_TYPES:
      return {
        ...state,
        factoryProductTypeList: action.payload,
      };

    default:
      return state;
  }
};

export default BomTypeReducer;
